export const styles = [
  {
     StyleName:"Traditional",StyleID:1,Code:"TRD"
  },
  {
     StyleName:"Modern Farmhouse",StyleID:2,Code:"MFH"
  },
  {
     StyleName:"Timber",StyleID:3,Code:"TMB"
  },
  {
     StyleName:"Coastal",StyleID:4,Code:"CST"
  },
  {
     StyleName:"Prairie",StyleID:5,Code:"PRR"
  },
  {
     StyleName:"Modern",StyleID:6,Code:"MDN"
  },
  {
     StyleName:"SW Prairie",StyleID:7,Code:"SWP"
  },
  {
     StyleName:"SW Modern",StyleID:8,Code:"SWM"
  },
  {
     StyleName:"Signature",StyleID:9,Code:"SGN"
  },
  {
     StyleName:"SW Signature",StyleID:11,Code:"SWS"
  }
];